import type {ReactElement} from 'react';
import React from 'react';
import type {SocialMediaAddDesignPanelProps} from "@Panels/social-media-add-design-panel/social-media-add-design-panel.types";
import {Modal} from "@Components/modal";
import {MODALS_IDS} from "@Components/modal-container";
import {LazyPanel} from "@Components/lazy-panel";
import {useModalData} from "@Components/modal/hooks/useModalData";
import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";

const PANEL_ID = 'social-media-add-design-panel';
export type SocialMediaAddDesignModalProps = SocialMediaAddDesignPanelProps;

export default function SocialMediaAddDesignModal(): ReactElement<any> {
  const modalData = useModalData(MODALS_IDS.SOCIAL_MEDIA_ADD_DESIGN_MODAL);
  const modalHeight = 'auto';
  const minModalHeight = '266px';
  const modalWidth = '912px';

  return (
    <Modal modalId={MODALS_IDS.SOCIAL_MEDIA_ADD_DESIGN_MODAL} panelId={PANEL_ID} modalHeight={modalHeight} modalWidth={modalWidth} modalMinHeight={minModalHeight}>
      <LazyPanel
        lazyPanelId={PANEL_ID}
        panelDirectoryName="social-media-add-design-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSocialMediaAddDesignModal = (props: SocialMediaAddDesignModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_MEDIA_ADD_DESIGN_MODAL,
      panelProps: props,
    })
  );
};